import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const EnablingUnitPwBD = () => {
  const members = [
    { sl: 1, name: 'Dr. M Jayasree', designation: 'Dean & Chairman, Professor, Department of Obstetrics and Gynaecology', contact: '9443769196' },
    { sl: 2, name: 'Dr. Sabaresh. V', designation: 'Member, Assistant Professor, Department of Orthopaedics', contact: '6379174259' },
    { sl: 3, name: 'Dr. G. Ramkumar', designation: 'Member, Assistant Professor, Department of ENT', contact: '8903486246' },
    { sl: 4, name: 'Dr. Snekalatha', designation: 'Member, Senior Resident, Department of Psychiatry', contact: '6380051705' },
    { sl: 5, name: 'Dr. Pavithra. V', designation: 'Member, Senior Resident, Department of Ophthalmology', contact: '8056686684' },
  ];

  const pdfPath = '/assets/document/committee/enabling-unit-PwBD/TMC-PwBD Enabling Unit..pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Enabling Unit for Persons with Benchmark Disabilities (PwBD)</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Enabling Unit for Persons with Benchmark Disabilities (PwBD) has been constituted to
          ensure an inclusive and barrier-free environment for students and staff with benchmark
          disabilities. The Unit facilitates accessibility, provides necessary support and
          accommodations, addresses grievances, and safeguards the rights and welfare of persons
          with disabilities. The Unit is constituted as per NMC Circular No. NMC/U-11021/24204/PwBD/2026
          dated 27.07.2026.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation and Department</th>
                <th>Contact Number</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.sl}>
                  <td className="ct-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation and Department">{m.designation}</td>
                  <td data-label="Contact Number">{m.contact}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="pharma-description pwbd-contact-section">
        <h2 className="pwbd-contact-title">Single Point Contact Details</h2>
        <p>
          <strong>Name:</strong> Dr. M Jayasree<br />
          <strong>Designation:</strong> Dean<br />
          <strong>Mobile Number:</strong> 8925969546<br />
          <strong>Mail Id:</strong>{' '}
          <a href="mailto:tmc.pwbdenablingunit@takshashilauniv.ac.in">
            tmc.pwbdenablingunit@takshashilauniv.ac.in
          </a>
        </p>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default EnablingUnitPwBD;
